<nz-modal [(nzVisible)]="isVisible"
          [nzFooter]="null"
          [nzWidth]="800"
          [nzBodyStyle]="{'width':'800px','max-height':'calc(100vh - 255px)','text-align': 'center','padding': '10px', 'overflow-y': 'auto'}"
          nzTitle=" "
          (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()"
          class="image-detail">
  <img *ngIf="imageSrc" [src]="imageSrc" class="image-content" alt="">
</nz-modal>
